import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trial-dialog',
  templateUrl: './trial-dialog.component.html',
  styleUrls: ['./trial-dialog.component.scss']
})
export class TrialDialogComponent implements OnInit {

  selectedPlan = "premium"
  constructor() { }

  ngOnInit(): void {
  }

}
